UTIL.registerTask('common', 'init', function () {
    (function ($) {
        $.fn.serializeObject = function () {
            var o = {};
            var a = this.serializeArray();
            $.each(a, function () {
                if (o[this.name] !== undefined) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            });
            return o;
        };


        /**
         * Randomize elements
         * @param selector
         * @returns {jQuery}
         */
        $.fn.randomize = function (selector) {
            var $elems = selector ? $(this).find(selector) : $(this).children(),
                $parents = $elems.parent();

            $parents.each(function () {
                $(this).children(selector).sort(function () {
                    return Math.round(Math.random()) - 0.5;
                    // }). remove().appendTo(this); // 2014-05-24: Removed `random` but leaving for reference. See notes under 'ANOTHER EDIT'
                }).detach().appendTo(this);
            });

            return this;
        };

        /**
         * Auto-growing textareas; technique ripped from Facebook
         *
         *
         * http://github.com/jaz303/jquery-grab-bag/tree/master/javascripts/jquery.autogrow-textarea.js
         */
        $.fn.autogrow = function (options) {
            return this.filter('textarea').each(function () {
                var self = this;
                var $self = $(self);
                var minHeight = $self.height();
                var noFlickerPad = $self.hasClass('autogrow-short') ? 0 : parseInt($self.css('lineHeight')) || 0;
                var settings = $.extend({
                    preGrowCallback: null,
                    postGrowCallback: null
                }, options);

                var shadow = $('<div></div>').css({
                    position: 'absolute',
                    top: -10000,
                    left: -10000,
                    width: $self.width(),
                    fontSize: $self.css('fontSize'),
                    fontFamily: $self.css('fontFamily'),
                    fontWeight: $self.css('fontWeight'),
                    lineHeight: $self.css('lineHeight'),
                    resize: 'none',
                    'word-wrap': 'break-word'
                }).appendTo(document.body);

                var update = function (event) {
                    var times = function (string, number) {
                        for (var i = 0, r = ''; i < number; i++) r += string;
                        return r;
                    };

                    var val = self.value.replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/&/g, '&amp;')
                        .replace(/\n$/, '<br/>&nbsp;')
                        .replace(/\n/g, '<br/>')
                        .replace(/ {2,}/g, function (space) {
                            return times('&nbsp;', space.length - 1) + ' '
                        });

                    // Did enter get pressed?  Resize in this keydown event so that the flicker doesn't occur.
                    if (event && event.data && event.data.event === 'keydown' && event.keyCode === 13) {
                        val += '<br />';
                    }

                    shadow.css('width', $self.width());
                    shadow.html(val + (noFlickerPad === 0 ? '...' : '')); // Append '...' to resize pre-emptively.

                    var newHeight = Math.max(shadow.height() + noFlickerPad, minHeight);
                    if (settings.preGrowCallback != null) {
                        newHeight = settings.preGrowCallback($self, shadow, newHeight, minHeight);
                    }

                    $self.height(newHeight);

                    if (settings.postGrowCallback != null) {
                        settings.postGrowCallback($self);
                    }
                };

                $self.change(update).keyup(update).keydown({event: 'keydown'}, update);
                $(window).resize(update);

                update();
            });
        };

        /*
         Method to adjust height of elements where they dynamically change height
         */
        $.fn.fitRows = function (options) {
            var cols = options.numColumns,
                $els = this.children(),
                maxH = 0, j,
                doSize;

            doSize = ( this.width() != $els.outerWidth(true) );

            $els.each(function (i, p) {

                var $p = $(p), h;

                $p.css('min-height', '');
                if (!doSize) return;

                maxH = Math.max($p.outerHeight(true), maxH);
                if (i % cols == cols - 1 || i == cols - 1) {
                    for (j = cols; j; j--) {
                        $p.css('min-height', maxH);
                        $p = $p.prev();
                    }
                    maxH = 0;
                }
            });
        };

        if ($.validator != undefined) {
            $.validator.addMethod(
                "regex",
                function (value, element, regexp) {
                    var re = new RegExp(regexp);
                    return this.optional(element) || re.test(value);
                },
                "Please check your input."
            );

            $.validator.setDefaults({
                errorElement: "span",
                errorClass: "help-block",
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('has-error');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('has-error');
                },
                errorPlacement: function (error, element) {
                    if (element.parent('.input-group').length || element.prop('type') === 'checkbox' || element.prop('type') === 'radio') {
                        error.insertAfter(element.parent());
                    } else {
                        error.insertAfter(element);
                    }
                }
            });
        }

        $.fn.countTo = function (options) {
            options = options || {};
            return $(this).each(function () {
                var settings = $.extend({}, $.fn.countTo.defaults, {
                    from: $(this).data('from'),
                    to: $(this).data('to'),
                    speed: $(this).data('speed'),
                    refreshInterval: $(this).data('refresh-interval'),
                    decimals: $(this).data('decimals')
                }, options);
                var loops = Math.ceil(settings.speed / settings.refreshInterval),
                    increment = (settings.to - settings.from) / loops;
                var self = this,
                    $self = $(this),
                    loopCount = 0,
                    value = settings.from,
                    data = $self.data('countTo') || {};
                $self.data('countTo', data);
                if (data.interval) {
                    clearInterval(data.interval);
                }
                data.interval = setInterval(updateTimer, settings.refreshInterval);
                render(value);

                function updateTimer() {
                    value += increment;
                    loopCount++;
                    render(value);
                    if (typeof (settings.onUpdate) == 'function') {
                        settings.onUpdate.call(self, value);
                    }
                    if (loopCount >= loops) {
                        $self.removeData('countTo');
                        clearInterval(data.interval);
                        value = settings.to;
                        if (typeof (settings.onComplete) == 'function') {
                            settings.onComplete.call(self, value);
                        }
                    }
                }

                function render(value) {
                    var formattedValue = settings.formatter.call(self, value, settings);
                    $self.html(formattedValue);
                }
            });
        };
        $.fn.countTo.defaults = {
            from: 0,
            to: 0,
            speed: 1000,
            refreshInterval: 100,
            decimals: 0,
            formatter: formatter,
            onUpdate: null,
            onComplete: null
        };

        function formatter(value, settings) {
            return value.toFixed(settings.decimals);
        }

        $.generateRandomPassword = function (limit) {
            limit = limit || 8;

            var password = '';

            var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789:;><!"£$%&/()=?^*°#_-@+[]{}|,.§ç';
            var list = chars.split('');
            var len = list.length, i = 0;

            do {
                i++;
                var index = Math.floor(Math.random() * len);
                password += list[index];
            } while (i < limit);

            return password;
        };

        if ($.fn.editable != undefined) {
            // Font Awesome support
            $.fn.editableform.buttons =
                '<button type="submit" class="btn btn-primary btn-sm editable-submit">' +
                '<i class="fa fa-fw fa-check"></i>' +
                '</button>' +
                '<button type="button" class="btn btn-default btn-sm editable-cancel">' +
                '<i class="fa fa-fw fa-times"></i>' +
                '</button>';

            $.fn.editableform.loading = '<div class="text-center"><i class="fa fa-spinner fa-spin"></i></div>';
        }

        if (typeof(Vue) != 'undefined') {
            Vue.transition("flip", {
                enterClass: "flipInX",
                leaveClass: "flipOutX"
            });


            Vue.directive('chosen', {
                twoWay: true,
                bind: function () {
                    return this.vm.$nextTick((function (_this) {
                        return function () {
                            var options = {};

                            if (_this.el.hasAttribute('chosen-options')) {
                                options = eval("(" + _this.el.getAttribute('chosen-options') + ")");
                            }

                            options.inherit_select_classes = false;
                            options.width = '100%';

                            return $(_this.el).chosen(options).change(function (ev) {
                                var i, len, option, ref, values;
                                if (_this.el.hasAttribute('multiple')) {
                                    values = [];
                                    ref = _this.el.selectedOptions;
                                    for (i = 0, len = ref.length; i < len; i++) {
                                        option = ref[i];
                                        values.push(option.value);
                                    }
                                    return _this.set(values);
                                } else {
                                    return _this.set(_this.el.value);
                                }
                            });
                        };
                    })(this));
                },
                update: function (nv, ov) {
                    return $(this.el).trigger('chosen:updated');
                }
            });

            Vue.directive('select2', {
                twoWay: true,
                priority: 1000,

                params: ['max-items', 'additional-options', 'selection'],

                bind: function () {
                    var self = this;

                    var options = {
                        maximumSelectionLength: self.params.maxItems,
                        theme: 'bootstrap',
                        closeOnSelect: true
                    };

                    if (typeof self.params.additionalOptions === 'object') {
                        for (var i in self.params.additionalOptions) {
                            options[i] = self.params.additionalOptions[i];
                        }
                    }

                    $(this.el)
                        .select2(options)
                        .on('change', function () {
                            var i, len, option, ref, values;
                            if (self.el.hasAttribute('multiple')) {
                                values = [];
                                ref = self.el.selectedOptions;
                                for (i = 0, len = ref.length; i < len; i++) {
                                    option = ref[i];
                                    values.push(option.value);
                                }

                                return self.set(values);
                            } else {
                                return self.set(self.el.value);
                            }
                        });

                    this.handler = function () {
                        $(this.el).trigger('change');
                    }.bind(this);

                    this.el.addEventListener('input', this.handler);
                },
                update: function (value, oldValue) {
                    // If a selection is set in the param, overwrite the value
                    if (this.params.selection) {
                        value = String(this.params.selection);
                    }

                    if (value !== undefined) {
                        $(this.el).val(value).trigger('change')
                    }
                },
                unbind: function () {
                    this.el.removeEventListener('input', this.handler);
                    $(this.el).off().select2('destroy');
                }
            });

            Vue.directive('select2-tagging', {
                twoWay: true,
                priority: 1000,

                params: ['max-items'],

                bind: function () {
                    var self = this;

                    $(this.el)
                        .select2({
                            theme: 'bootstrap',
                            closeOnSelect: true,
                            minimumInputLength: 3,
                            tags: true,
                            tokenSeparators: [',', '#'],
                            maximumSelectionLength: self.params.maxItems,

                            templateSelection: function (item) {
                                return '#' + item.text.replace('#', '');
                            },
                        })
                        .on('change', function () {
                            var i, len, option, ref, values;
                            if (self.el.hasAttribute('multiple')) {
                                values = [];
                                ref = self.el.selectedOptions;
                                for (i = 0, len = ref.length; i < len; i++) {
                                    option = ref[i];
                                    values.push(option.value);
                                }

                                return self.set(values);
                            } else {
                                return self.set(self.el.value);
                            }
                        })

                    this.handler = function () {
                        $(this.el).trigger('change');
                    }.bind(this);

                    this.el.addEventListener('input', this.handler)
                },
                update: function (value) {
                    if (value !== undefined) {
                        $(this.el).val(value).trigger('change')
                    }
                },
                unbind: function () {
                    $(this.el).off().select2('destroy')
                }
            });

            Vue.directive('datetime', {
                twoWay: true,
                priority: 1000,
                bind: function () {
                    var self = this;

                    $(this.el).datetimepicker({
                        showClear: true,
                        widgetPositioning: {
                            vertical: 'top'
                        },
                        icons: {
                            time: "fa fa-clock-o",
                            date: "fa fa-calendar",
                            clear: "fa fa-times",
                            up: "fa fa-arrow-up",
                            down: "fa fa-arrow-down"
                        }
                    }).on('dp.change', function() {
                        return self.set(self.el.value);
                    });
                },
                update: function (value, oldValue) {
                    $(this.el).val(value).trigger('dp.change')
                },
                unbind: function () {
                    $(this.el).off().datetimepicker('destroy');
                }
            });

            Vue.directive('radio', {
                twoWay: true,
                bind: function () {
                    var self = this;
                    var btns = $(self.el).find('.btn');
                    btns.each(function () {
                        $(this).on('click', function () {
                            var v = $(this).find('input').get(0).value;
                            self.set(v);
                        })
                    });
                },
                update: function () {
                    var value = this._watcher.value;
                    if (value) {
                        this.set(value);
                        var btns = $(this.el).find('.btn')
                        btns.each(function () {
                            $(this).removeClass('active');
                            var v = $(this).find('input').get(0).value;

                            if (v == value) {
                                $(this).addClass('active');
                            }
                        });
                    } else {
                        var input = $(this.el).find('.active input').get(0);
                        if (input) {
                            this.set(input.value);
                        }
                    }
                }
            });

            var SummerNoteComponent = Vue.extend({
                replace: true,
                inherit: false,
                props: {
                    model: {
                        required: true,
                        twoWay: true
                    },
                    language: {
                        type: String,
                        required: false,
                        default: "en-US"
                    },
                    height: {
                        type: Number,
                        required: false,
                        default: 500
                    },
                    minHeight: {
                        type: Number,
                        required: false,
                        default: 200
                    },
                    maxHeight: {
                        type: Number,
                        required: false,
                        default: 800
                    },
                    toolbar: {
                        type: Array,
                        required: false,
                        default: function () {
                            return [
                                ["font", ["bold", "italic", "underline", "clear"]],
                                ["fontsize", ["fontsize"]],
                                ["para", ["ul", "ol", "paragraph"]],
                                // ["color", ["color"]],
                                // ["insert", ["link", "picture", "hr"]]
                            ];
                        }
                    }
                },
                beforeCompile: function () {
                    this.isChanging = false;
                    this.control = null;
                },
                ready: function () {
                    if (this.minHeight > this.height) {
                        this.minHeight = this.height;
                    }
                    if (this.maxHeight < this.height) {
                        this.maxHeight = this.height;
                    }
                    var me = this;
                    this.control = $(this.$el);
                    this.control.summernote({
                        lang: this.language,
                        height: this.height,
                        minHeight: this.minHeight,
                        maxHeight: this.maxHeight,
                        toolbar: this.toolbar,
                        onInit: function () {
                            me.control.code(me.model);
                        },
                        onChange: function() {
                            if (!me.isChanging) {
                                me.isChanging = true;
                                var code = me.control.code();
                                me.model = (code === null || code.length === 0 ? null : code);
                                me.$nextTick(function () {
                                    me.isChanging = false;
                                });
                            }
                        }
                    });
                },
                watch: {
                    model: function (val, oldVal) {
                        if (!this.isChanging) {
                            this.isChanging = true;
                            var code = (val === null ? "" : val);
                            this.control.code(code).trigger("summernote.change");
                            this.isChanging = false;
                        }
                    }
                }
            });

            Vue.component('summernote', SummerNoteComponent);
        }
    })(jQuery);
});
